export default "__VITE_ASSET__tEmS6tAT__"